import type { ReadinessState } from 'types/readiness';
import type { PaywallContext } from 'types/paywall';

/**
 * Builds the §8.0 paywall payload for a Mini-League Readiness funnel.
 *
 * The single metric is the gap to the winner — the exact figure the user has
 * already seen as the hatched zone of the verdict GapBar:
 *  - pre-GW1  → `readinessVerdict.gap` (winnersTarget − score)
 *  - post-GW1 → `raceVerdict.gap` (real points behind the leader)
 *
 * Returns null until the relevant verdict has been calculated, so the paywall
 * falls back to its generic copy.
 *
 * The league name is optional in the funnel (the naming step is skippable),
 * so it falls back to a generic "your mini-league" rather than rendering an
 * empty label on the paywall.
 */
const DEFAULT_LEAGUE_NAME = 'your mini-league';

export const buildReadinessPaywallContext = (
  state: ReadinessState,
  isPostGw1: boolean
): PaywallContext | null => {
  if (isPostGw1) {
    if (!state.raceVerdict) return null;
    return {
      metricValue: state.raceVerdict.gap,
      leagueName: state.raceVerdict.leagueName || DEFAULT_LEAGUE_NAME
    };
  }

  if (!state.readinessVerdict) return null;
  return {
    metricValue: state.readinessVerdict.gap,
    leagueName: state.leagueName || DEFAULT_LEAGUE_NAME
  };
};
